import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { CustomSuccessToast } from '@shared/components/customSuccessToast';
import { useAppSelector } from '@shared/store';

export const WELCOME_TOAST_SHOWN_KEY = 'welcomeToastShown';

export const useWelcomeToast = () => {
  const { t } = useTranslation();
  const currentCompany = useAppSelector((state) => state.auth.authenticatedUserCompany);

  useEffect(() => {
    const companyTitle = currentCompany?.title;

    if (!companyTitle || sessionStorage.getItem(WELCOME_TOAST_SHOWN_KEY)) {
      return;
    }

    sessionStorage.setItem(WELCOME_TOAST_SHOWN_KEY, 'true');

    toast.success(CustomSuccessToast, {
      closeButton: false,
      autoClose: 5000,
      icon: false,
      data: {
        title: t('auth.welcomeToast.title', { company: companyTitle }),
        description: t('auth.welcomeToast.description'),
      },
    });
  }, [currentCompany?.title, t]);
};
